var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"provider-category"},[_c('span',{class:['icon', _vm.iconName]}),_c('span',{staticClass:"name"},[_vm._v("\n    "+_vm._s(_vm.category.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }